import { useState } from 'react'

import { linkPreviewCutoff } from '../threadTimeline'
import type { SupportMessage } from '../types'

interface CapturedCutoff {
  ticketPublicId: string
  boundToLoadedThread: boolean
  since: string | null
}

const unbound = (ticketPublicId: string): CapturedCutoff => ({
  ticketPublicId,
  boundToLoadedThread: false,
  since: null,
})

// The ten-message limit is about what the first load asks the service to unfurl,
// not a window that slides. Captured once per thread, during render the way the
// unread window is, so the eleventh reply never pulls a card out from above the
// reader and shifts the conversation under them. It waits for the load to finish
// because the store empties the thread before fetching it: a reply arriving in
// that gap would otherwise set the cut-off from a one-message thread and let the
// whole history unfurl.
export const useLinkPreviewCutoff = (
  ticketPublicId: string,
  messages: SupportMessage[],
  loading: boolean,
): string | null => {
  const [captured, setCaptured] = useState(() => unbound(ticketPublicId))

  if (captured.ticketPublicId !== ticketPublicId) {
    const opened = unbound(ticketPublicId)
    setCaptured(opened)
    return opened.since
  }

  if (!captured.boundToLoadedThread && !loading && messages.length > 0) {
    const loaded = {
      ...captured,
      boundToLoadedThread: true,
      since: linkPreviewCutoff(messages),
    }
    setCaptured(loaded)
    return loaded.since
  }

  return captured.since
}
